import React, { useEffect, useState } from 'react'
import './Designation.css'
import { Button, Card, Col, Row, Table, Modal, Form, Input, Space } from 'antd';
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircleFilled, ClockCircleFilled, LeftOutlined, RightOutlined,DeleteOutlined } from '@ant-design/icons';
import { BsMap, BsPencil } from "react-icons/bs";
import { StopOutlined } from '@ant-design/icons';
import { AddDesignation, BASE_URL, DeleteDesignation, FetchDesignation, UpdateDesignation } from '../../utils/constant';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import SignUpSidebar from '../../common/SignUpSidebar';
import { setDesig } from '../../store/slices/designationSlice';
import ModalConfirm from '../../common/modalConfirm';
import Right from '../../assets/icons/right.svg';
import Left from '../../assets/icons/left.svg';
function Designation() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const capitalizeFirstLetter = (str) => {
        return str?.replace(/\b\w/g, (char) => char.toUpperCase());
      };
    const [designationData, setDesignationData] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { handleSubmit, register, reset } = useForm();
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const {
        companyName = "",
        firstName = "",
        lastName = "",
        email = "",
        phoneNumber = "",
        aadharNumber = "",
      } = useSelector((state) => state.signUp.signUpDetails);
      const [modalDeleteDesigVisible, setModalDeleteDesigVisible] = useState(false);
      const [deleteDesigData, setDeleteDesigData] = useState(null);
  
      const deleteDesig = (params) => {
        setModalDeleteDesigVisible(true);
        setDeleteDesigData(params)      
      };
      const handleDesigOk = (params) => {
        console.log('deleteDepartment')
  
        handleDelete(params)     
        setModalDeleteDesigVisible(false);
      };
      const handleDesigCancel = () => {
        setModalDeleteDesigVisible(false);
      };
    const [form] = Form.useForm(); 

    const handlecompany = () => {
        navigate('/addshift');
    }
    const addcompany = () => {
        navigate('/departmentandsubdepartment');
    }
    useEffect(() => {
        form.resetFields();
        // setSelectedDesignation(null)
      }, [form]);
    const showModal = () => {
        form.resetFields();

        setIsModalVisible(true);
    };

    const handleOk = async () => {
        try {
            await form.validateFields(); // Validate form fields
            const values = form.getFieldsValue(); // Get form values
            let isError = false;

            // Validate each required field
            const requiredFields = [
              "designationName",
              "designationShortName",
            ];
        
            requiredFields.forEach((fieldName) => {
              if (!values[fieldName] && values[fieldName] !== 0) {
                toast.error(`Please fill in the ${fieldName.replace(/([A-Z])/g, ' $1').toLowerCase()} field.`);
                isError = true;
              }
            });
        
            // If any error occurred, return early
            if (isError) {
              return;
            }
            if (selectedDesignation) {
                // If selectedDesignation exists, it means we are updating an existing designation
                await onUpdate(values);
            } else {
                // If selectedDesignation is null, it means we are adding a new designation
                await onFinish(values);
            }            console.log(selectedDesignation)
        } catch (error) {
            console.error('Error validating fields:', error);
        }
    };

    const handleCancel = () => {
        setIsModalVisible(false);
        form.resetFields(); // Reset Ant Design form fields
        setSelectedDesignation(null);

    };
    const onUpdate = async (values) => {
        const updatedDesignation = {
            ...selectedDesignation,
            ...values,
        };

    console.log('values',values)
    console.log('updatedDesignation',updatedDesignation)
        const token = localStorage.getItem('authToken');
    
        try {
            const response = await fetch(`${BASE_URL}/${UpdateDesignation}/${selectedDesignation?.designationId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${token}`,
                },
                body: JSON.stringify(values),
            });
    
            if (response.ok) {
                toast.success('Designation updated successfully!', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                getDsignationList();
                reset();
                handleCancel();
            } else {
                const data = await response.json();
                toast.error(data.errorMessage, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error updating designation:', error);
        }
    };
    const onFinish = async (values) => {
        console.log('value',values)
        const FinalAdddesignation = {
            designations : [values]
        }
        const token = localStorage.getItem('authToken');

        try {
            const response = await fetch(`${BASE_URL}/${AddDesignation}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `${token}`,
                },
                body: JSON.stringify(FinalAdddesignation),
            });

            if (response.ok) {
                toast.success('Designation added successfully!', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                getDsignationList();
                reset();
                handleCancel();
            } else {
                const data = await response.json();
                toast.error(data.errorMessage, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        } catch (error) {
            console.error('Error adding designation:', error);
        }
    };
    const handleDelete = async (designationId) => {
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${DeleteDesignation}/${designationId}`, {
            method: "PUT",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({}),
          });
          
          if (response.ok) {
            const data = await response.json();
            console.log('designation',data)
            getDsignationList();
      
          
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
        await fetchData();
    }
    const handleEdit = async (designation) => {
        // form.resetFields(); // Reset the form
        // form.setFieldsValue(designation)
        setSelectedDesignation(null); // Reset the selected designation
        setSelectedDesignation(designation);
        showModal();
    };
    useEffect(() => {
        if (!selectedDesignation || Object.keys(selectedDesignation).length === 0) {
          // If initialValues is null or an empty object, set form fields to be empty
          form.resetFields();
        } else {
          form.setFieldsValue(selectedDesignation);
        }
      }, [selectedDesignation, form]);
    useEffect(() => {
        getDsignationList();
      }, []);
      const getDsignationList = async () =>{
        const token = localStorage.getItem('authToken');
      
        const fetchData = async () => {
          const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
            method: "POST",
             headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `${token}`,
                      
                    },
            body: JSON.stringify({isDeleted:false}),
          });
          
          if (response.ok) {
            const data = await response.json();
            const activeDesignation = data.data.filter(item => item.isActive);
            console.log('department',data)
            setDesignationData(activeDesignation)
            const newArray = activeDesignation.map((item) => ({
                value: item.designationName,
                key: item.designationId
              }));
              sessionStorage.setItem('designation', JSON.stringify(newArray));
              dispatch(setDesig(newArray));
          
          } else {
            const data = await response.json();
            console.log('departmenterr',data)
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
            
          }
        };
        await fetchData();
      }
    const columns = [
        {
            title: 'S. No.',
            dataIndex: 'sno',
        },
        {
            title: <>Department <br />Name</>,
            dataIndex: 'department',
        },
        {
            title: <>Name<br />(short)</>,
            dataIndex: 'name',
        },
        {
            title: 'Description',
            dataIndex: 'description',
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
             
        },

    ];
    // const data = [];
    // for (let i = 0; i < 7; i++) {
    //     data.push({
    //         key: i,
    //         sno: '1',
    //         department: <>
    //             <p className='desig-sale'>Sales</p>
    //         </>,
    //         name: <>
    //             <p className='desig-sale'>Sales</p>
    //         </>,
    //         description: <>
    //             <p className='desig-lorem'>Lorem Ipsum dolor sir</p>
    //         </>,
    //         actions: <><div className='flex' style={{justifyContent:'center',display:'flex'}}>
    //         <BsPencil style={{border:'1px solid #D7E7F8',padding:'3px',backgroundColor:'#D7E7F8',borderRadius:'50%',fontSize:'17px'}}/>
    //         <DeleteOutlined style={{border:'1px solid #D7E7F8',padding:'3px',backgroundColor:'#F5E7E9',borderRadius:'50%',fontSize:'10px',color:'#DC3545',marginLeft:'5px'}}/>
    //       </div></>,
    //     });
    // }
    const tableData = designationData.map((item, index) => ({
        key: index,
        sno: index + 1,
        department: <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 w-[148px] h-[30px] inline-flex items-center"><span className='truncate'>{capitalizeFirstLetter(item.designationName)}</span></p>,
        name: <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 w-[148px] h-[30px] inline-flex items-center"><span className='truncate'>{capitalizeFirstLetter(item.designationShortName)}</span></p>,
        description: <p className="mb-1 rounded-[28px] bg-[rgba(0,48,95,0.09)] text-sm px-3 w-[148px] inline-flex h-[30px] items-center"><span className='truncate'>{capitalizeFirstLetter(item.designationDescription)}</span></p>,
        actions: (
            <div className="inline-flex mb-1 mx-auto">
                <span className='shi-pen'><BsPencil  onClick={() => handleEdit(item)}/></span>
                <span className='shi-not ml-2'><StopOutlined  onClick={() => deleteDesig(item.designationId)}/></span>
            </div>
        ),
    }));

    return (
        <>
                      <ToastContainer position="top-right" autoClose={2000} />

                      <div className="h-full">
        <Row className="2xl:h-full xl:h-auto">
            <SignUpSidebar isDesignation={ true } location={location.pathname} />
                <Col lg={14} className="bg-[#F5FBFE] h-full text-base overflow-auto">
                    <div className=" flex flex-col pt-10">
                        <div className='font-bold text-[28px] text-center mt-3 mb-4'>Designations</div>
                        <div className='desig-org-table'>
                            <Table className='' columns={columns} dataSource={tableData} pagination={false} />
                        </div>
                        <div className='desig-center'>
                            <Button className='ant-btn css-dev-only-do-not-override-3mqfnx ant-btn-default h-10 border !border-[#00305F] text-[#00305F] rounded-full hover:bg-[#00305F] hover:!text-white px-4 !outline-none' onClick={showModal}><span className='font-sbold text-sm'>+Add More Designations</span></Button>
                            {/* <p className='desig-add-plush'>+Add More Company</p> */}
                        </div>
                        <div className='flex gap-2 justify-end px-5 mt-5'>
                            <img src={Left} onClick={addcompany} className='w-12 cursor-pointer'/>
                            <img src={Right} onClick={handlecompany} className='w-12 cursor-pointer'/>
                        </div>
                    </div>
                </Col>
            </Row>

                    </div>
            <Modal title="Add Designation"
             open={isModalVisible}
             okButtonProps={{ style: { background: 'grey' } }}
              onOk={handleOk} onCancel={handleCancel} footer={null}>
                <Form form={form} onFinish={onFinish}
                style={{ display: 'flex', flexDirection: 'column' }}
                //  initialValues={selectedDesignation || undefined}
                 >
                    <div className="pro-add-work-back ml-2 mr-2 !px-5 !pb-4">
                        <div className="block">
                            <Form.Item className='shiftLabell mb-2 [&_label]:mb-0' label={<span>Designation Name <span className='text-red-500'>*</span></span>} name="designationName">
                                <Input className="h-10 bg-[#BACAD8] rounded-full !px-5 w-full placeholder:text-[13px] border-none !outline-none"/>
                            </Form.Item>
                            <Form.Item className='shiftLabell mb-2 [&_label]:mb-0' label={<span>Short Name<span className='text-red-500'>*</span> (Maximum 5 letters are allowed)</span>} name="designationShortName">
                                <Input maxLength={5} className="h-10 bg-[#BACAD8] rounded-full !px-5 w-full placeholder:text-[13px] border-none !outline-none"/>
                            </Form.Item>
                            <Form.Item className='shiftLabel [&_label]:mb-0 mb-0' label="Description" name="designationDescription">
                                <Input.TextArea rows={3} className="bg-[#BACAD8] rounded-[10px] !px-5 w-full placeholder:text-[13px] border-none !outline-none !resize-none"/>
                            </Form.Item>
                        </div>
                    </div>
                    <div className="text-center mt-4">
                        <Button className="!border-[#00305F]  text-[#00305F] hover:bg-[#00305F] hover:!text-[#fff] rounded-full py-2 px-5 h-auto !text-sm" onClick={handleOk}>
                            <span className="font-sbold">+Add Designation</span>
                        </Button>
                    </div>
                </Form>
            </Modal>
            <ModalConfirm
        visible={modalDeleteDesigVisible}
        onOk={() => handleDesigOk(deleteDesigData)}
        onCancel={handleDesigCancel}
        title="Delete"
        content="Are you sure you want to delete?"
      />
        </>
    )
}

export default Designation